
	/**
	 * @description
	 *	Mapeo entre los IDs de causas de notas de CyR/NC de la base de datos,
	 *	a nombres enumerados, lo que permite modificar el sistema rápidamente
	 *	cuando la base de datos se modifique sobre el modelo OrderEventType.
	 */

export enum OrderEventTypeId {

	// = 0,
	BrokenCaseOrContainer = 1,
	DefectiveProduct = 2,
	ContentIncomplete = 3,
	WrongProductShadeFraganceOrSize = 4,
	ProductInvoicedDoesNotMatchProductShipped = 5,
	ProductInvoicedAndNotShipped = 6,
	// = 7,
	// = 8,
	WaiverToProductsPurchasedWithPaymentCycles = 9,
	UnsatisfactorySubstitutions = 10,
	Disarm = 11,
	ProductPurchasedWithPaymentCyclesWithoutStock = 12
}

export const toOrderEventTypeIdString = function (orderEventTypeId: OrderEventTypeId): string {
	switch (orderEventTypeId) {
		case OrderEventTypeId.BrokenCaseOrContainer:
			return "Estuche o envase roto";
		case OrderEventTypeId.DefectiveProduct:
			return "Producto defectuoso";
		case OrderEventTypeId.ContentIncomplete:
			return "Contenido incompleto";
		case OrderEventTypeId.WrongProductShadeFraganceOrSize:
			return "Producto, tono, fragancia o talle erróneo";
		case OrderEventTypeId.ProductInvoicedDoesNotMatchProductShipped:
			return "Producto facturado no corresponde al producto enviado";
		case OrderEventTypeId.ProductInvoicedAndNotShipped:
			return "Producto facturado y no enviado";
		case OrderEventTypeId.WaiverToProductsPurchasedWithPaymentCycles:
			return "Renuncia de productos comprados en cuotas";
		case OrderEventTypeId.UnsatisfactorySubstitutions:
			return "Sustitución insatisfactoria";
		case OrderEventTypeId.Disarm:
			return "Desarme";
		case OrderEventTypeId.ProductPurchasedWithPaymentCyclesWithoutStock:
			return "Producto en cuotas cortado en facturación";
		default: {
			return "[Unknown OrderEventTypeId]";
		}
	}
};
